/* eslint-disable */
import { create } from 'zustand';
import { subscribeWithSelector } from 'zustand/middleware';
import { handleDefaultDataSet, keyChangeFunction } from './Services/stateChangeService';
import {
	initialStatsSummary,
	initialTabs,
	initialAnalysisTabs,
	initialQCTypes,
	initialConfigTypes,
	initialTimeRangesDropdown,
	initialFailureParameters,
	productWiseDropdown,
	geographyWiseDropdown,
	initialAnalysisData,
	initialStatisticalAnalysisData,
	machineParameters,
} from './tempData';

export const useQualityAnalysisStore = create(
	subscribeWithSelector((set, get) => ({
		loading: false,
		setLoading: (loading) => set({ loading }),
		suppressNotification: false,
		setSuppressNotification: (suppressNotification) => set({ suppressNotification: suppressNotification }),
		// statsSummary: initialStatsSummary,
		// setStatsSummary: (statsSummary) => set({ statsSummary }),
		tabs: initialTabs,
		activeTab: initialTabs.find((t) => t.active)?.key || initialTabs[0].key,
		// setTabs: (tabs) => set({
		// 	tabs,
		// 	activeTab: tabs.find(t => t.active)?.key || tabs[0].key,
		// }),
		setActiveTab: (key) =>
			set((state) => ({
				tabs: state.tabs.map((tab) => ({
					...tab,
					active: tab.key === key,
				})),
				activeTab: key,
				cardData: [],
				statisticalAnalysisData: initialStatisticalAnalysisData,
			})),

		analysisTabs: initialAnalysisTabs,
		activeAnalysisTab:
			initialAnalysisTabs.find((t) => t.active)?.key ||
			initialAnalysisTabs[0].key,
		// setAnalysisTabs: (analysisTabs) => set({
		// 	analysisTabs,
		// 	activeAnalysisTab: analysisTabs.find(t => t.active)?.key || analysisTabs[0].key,
		// }),
		setActiveAnalysisTab: (key) => {
			set((state) => ({
				analysisTabs: state.analysisTabs.map((tab) => ({
					...tab,
					active: tab.key === key,
				})),
				activeAnalysisTab: key,
				cardData: [],
				statisticalAnalysisData: initialStatisticalAnalysisData,
			}))
			handleDefaultDataSet(key, get());
			return;
		},

		// QC Types
		qcTypes: initialQCTypes,
		activeQCType:
			initialQCTypes.find((t) => t.active)?.key || initialQCTypes[0].key,
		setActiveQCType: (key) =>
			set((state) => ({
				qcTypes: state.qcTypes.map((t) => ({
					...t,
					active: t.key === key,
				})),
				activeQCType: key,
				cardData: [],
				statisticalAnalysisData: initialStatisticalAnalysisData,
			})),
		defaultAnalysisData: {},
		setDefaultAnalysisData: (defaultAnalysisData) =>
			set((state) => ({
				defaultAnalysisData: defaultAnalysisData ?? state.defaultAnalysisData,
			})),
		// Config Types
		configTypes: initialConfigTypes,
		activeConfigType:
			initialConfigTypes.find((t) => t.active)?.key ||
			initialConfigTypes[0].key,
		setActiveConfigType: (key) =>
			set((state) => ({
				configTypes: state.configTypes.map((t) => ({
					...t,
					active: t.key === key,
				})),
				activeConfigType: key,
				cardData: [],
				statisticalAnalysisData: initialStatisticalAnalysisData,
			})),

		chartSelectionObj: null,
		setChartSelectionObj: (obj) => set({ chartSelectionObj: obj }),

		// Time Ranges
		timeRangesDropdown: initialTimeRangesDropdown,
		activeTimeRangeDropdown:
			initialTimeRangesDropdown.find((t) => t.active)?.key ||
			initialTimeRangesDropdown[0].key,
		setActiveTimeRange: (key) =>
			set((state) => ({
				timeRangesDropdown: state.timeRangesDropdown.map((t) => ({
					...t,
					active: t.key === key,
				})),
				activeTimeRangeDropdown: key,
			})),

		globalProductList: [],
		setGlobalProductList: (globalProductList) => set({ globalProductList }),
		// Product Wise Dropdown
		productWiseDropdown: productWiseDropdown,
		activeProductWiseDropdown:
			productWiseDropdown.find((t) => t.active)?.key ||
			productWiseDropdown[0].key,
		setActiveProductWiseDropdown: (key) =>
			set((state) => ({
				productWiseDropdown: state.productWiseDropdown.map((t) => ({
					...t,
					active: t.key === key,
				})),
				activeProductWiseDropdown: key,
			})),

		// Geography Wise Dropdown
		geographyWiseDropdown: geographyWiseDropdown,
		activeGeographyWiseDropdown:
			geographyWiseDropdown.find((t) => t.active)?.key ||
			geographyWiseDropdown[0].key,
		setActiveGeographyWiseDropdown: (key) =>
			set((state) => ({
				geographyWiseDropdown: state.geographyWiseDropdown.map((t) => ({
					...t,
					active: t.key === key,
				})),
				activeGeographyWiseDropdown: key,
			})),

		// Date Range - legacy format - will be deprecated
		dateRangeObj: {
			from: null, // Date object for from date
			to: null, // Date object for to date
			viewFormat: {
				// Formatted strings for display
				from: '',
				to: '',
			},
		},
		setDateRangeObj: (dateRangeObj) =>
			set((state) => ({
				dateRangeObj: { ...state.dateRangeObj, ...dateRangeObj },
			})),

		// Detailed date information for backend
		dateInfo: {
			year: new Date().getFullYear(),
			month: new Date().getMonth() + 1,
			day: new Date().getDate(),
			quarter: Math.floor((new Date().getMonth() + 3) / 3),
			week: null,
			period: 'year', // 'day', 'month', 'quarter', 'year'
		},
		setDateInfo: (dateInfo) =>
			set((state) => ({
				dateInfo: { ...state.dateInfo, ...dateInfo },
			})),
		searchQuery: '',
		setSearchQuery: (searchQuery) => set({ searchQuery }),

		// Failure Parameters
		qualityAnalysisParameters: initialFailureParameters,
		setQualityAnalysisParameters: (qualityAnalysisParameters) =>
			set({ qualityAnalysisParameters: [...machineParameters, ...qualityAnalysisParameters] }),
		selectedQualityAnalysisParameter: 'all',
		setSelectedQualityAnalysisParameter: (selectedParam) =>
			set({ selectedQualityAnalysisParameter: selectedParam, selectedQualityParameterProduct: null, searchQuery: '', cardData: [], statisticalAnalysisData: initialStatisticalAnalysisData }),

		qualityAnalysisChartData: initialAnalysisData,
		setQualityAnalysisChartData: (qualityAnalysisChartData) =>
			set({ qualityAnalysisChartData }),

		qualityParameterProducts: [],
		setQualityParameterProducts: (qualityParameterProducts) =>
			set({ qualityParameterProducts }),
		selectedQualityParameterProduct: null,
		setSelectedQualityParameterProduct: (selectedQualityParameterProduct) =>
			set({ selectedQualityParameterProduct, cardData: [], statisticalAnalysisData: initialStatisticalAnalysisData }),

		cardData: [],
		triggerChartUpdateApiCall: false,
		dateRangeExport: {
			date: {
				from: null,
				to: null,
			},
		},
		setDateRangeExport: (dateRangeExport) => {
			set({ dateRangeExport });
			// keyChangeFunction('dateRangeExport', dateRangeExport, get().dateRangeExport);
		},
		setCardData: (newCardData, triggerUpdate = false) => {
			let prev = get().triggerChartUpdateApiCall;
			if (triggerUpdate) {
				set({
					cardData: newCardData,
					triggerChartUpdateApiCall: !prev,
					...(newCardData.length === 0 && { statisticalAnalysisData: initialStatisticalAnalysisData })
				});
				return;
			}
			set({
				cardData: newCardData,
			});
		},
		statisticalLoading: false,
		setStatisticalLoading: (statisticalLoading) =>
			set({ statisticalLoading }),

		statisticalAnalysisData: initialStatisticalAnalysisData,
		setStatisticalAnalysisData: (statisticalAnalysisData) =>
			set({ statisticalAnalysisData }),

		collapsedCards: [],
		setCollapsedCards: (collapsedCards) => set({ collapsedCards }),

		timeFrame: 'Daily',
		setTimeFrame: (timeFrame) => {
			set({ timeFrame, cardData: [], statisticalAnalysisData: initialStatisticalAnalysisData });
		},
		// ImagesFinder Filters for Statistical Analysis (single source of truth)
		imagesFinderFilters: {},
		setImagesFinderFilters: (imagesFinderFilters) => set({ imagesFinderFilters }),

		// Trigger for filter apply (like export button pattern)
		triggerFilterApply: false,
		applyImagesFinderFilters: () => set({ triggerFilterApply: !get().triggerFilterApply }),
		triggerExportApiCall: false,
		setTriggerExportApiCall: () => set({ triggerExportApiCall: !get().triggerExportApiCall }),

		// Extra button info from URL (for external navigation)
		extraButtonInfo: null,
		setExtraButtonInfo: (extraButtonInfo) => set({ extraButtonInfo }),

		// Flag to track if state was initialized from URL
		isUrlInitialized: false,
		setIsUrlInitialized: (isUrlInitialized) => set({ isUrlInitialized }),

	}))
);
